// extracted by mini-css-extract-plugin
export default {"wrapper":"introductionjackbox2_wrapper__NmKro","button":"introductionjackbox2_button__QHAIN"};